import React from "react"
import { Action, ActionType } from "@tenforce/toolbox-button-push-react"
import { ColorName } from "@tenforce/toolbox-default-style"

import { useAppDispatch, useAppSelector } from "../../../hooks"
import { GlobalState } from "../../../store"
import { formatString } from "../../../util/Strings"

import { ISuggestedAction } from ".."
import { addMessage } from "../slice"
import classNames from "classnames"

export interface Props {
    id: string
    addSuggestedActions: (suggestedActions: ISuggestedAction[]) => void
}

export default function SuggestedActions(props: Props): JSX.Element {
    const { addSuggestedActions, id } = props
    const aiModalData = useAppSelector(
        (state: GlobalState) => state.aIModal.modals[id],
    )
    if (!aiModalData) {
        return <></>
    }

    const dispatch = useAppDispatch()

    const { suggestedActions, labels, isLoading } = aiModalData

    if (suggestedActions.length === 0) {
        return <></>
    }

    const classes = classNames("tw-flex tw-flex-col tw-items-start", {
        "is-loading": isLoading,
    })

    return (
        <div className={classes} data-ft-testid="suggestedActions">
            {suggestedActions.length > 1 && (
                <Action
                    actionType={ActionType.button}
                    data-ft-testid="addAllSuggestedActions"
                    isTransparent={true}
                    textColor={ColorName.Goldenrod}
                    extraClasses="tw-mt-0 tw-max-w-full"
                    onClick={(): void => {
                        dispatch(
                            addMessage({
                                id,
                                message: labels.addAllSuggestedActions,
                                isSentByUser: true,
                            }),
                        )
                        addSuggestedActions(suggestedActions)
                    }}
                >
                    {labels.addAllSuggestedActions}
                </Action>
            )}

            {suggestedActions.map((suggestedAction) => {
                const message = formatString(
                    labels.addSuggestedAction,
                    suggestedAction.title,
                )
                return (
                    <Action
                        actionType={ActionType.button}
                        data-ft-testid="suggestedAction"
                        data-ft-id={suggestedAction.id}
                        data-ft-title={suggestedAction.title}
                        isTransparent={true}
                        textColor={ColorName.Goldenrod}
                        key={`ai_action_${suggestedAction.id}`}
                        extraClasses="tw-mt-0 tw-max-w-full"
                        onClick={(): void => {
                            dispatch(
                                addMessage({
                                    id,
                                    message,
                                    isSentByUser: true,
                                }),
                            )
                            // we use the same endpoint, so we send it as an array
                            addSuggestedActions([suggestedAction])
                        }}
                    >
                        {message}
                    </Action>
                )
            })}
        </div>
    )
}
